import React from "react";
import { RiVipDiamondLine } from "react-icons/ri";
import { FaRegClock } from "react-icons/fa";
import { IoGameControllerOutline } from "react-icons/io5";
import useWindowSize from "@/hooks/useWindowSize";
import "./DevourPlayStats.scss";

interface DevourPlayStatsProps {
    earned: number;
    playtime: string;
    gamesPlayed: number;
    className?: string;
    forceMobileView?: boolean;
}

/**
 * Stats display with desktop and mobile variants
 * Desktop: Shows icons with labels
 * Mobile: Shows icons only for space efficiency
 */
const DevourPlayStats: React.FC<DevourPlayStatsProps> = ({
    earned,
    playtime,
    gamesPlayed,
    className = "",
    forceMobileView,
}) => {
    const [windowWidth] = useWindowSize();
    const isMobile = forceMobileView === true ? true : windowWidth > 0 ? windowWidth < 768 : false;

    return (
        <div className={`devourplay-stats ${isMobile ? "devourplay-stats--mobile" : "devourplay-stats--desktop"} ${className}`}>
            <div className="devourplay-stats__item">
                <RiVipDiamondLine className="devourplay-stats__icon" />
                <div className="devourplay-stats__content">
                    <span className="devourplay-stats__value">{earned.toLocaleString()}</span>
                    {!isMobile && <span className="devourplay-stats__label">XP Earned</span>}
                </div>
            </div>
            <div className="devourplay-stats__item">
                <FaRegClock className="devourplay-stats__icon" />
                <div className="devourplay-stats__content">
                    <span className="devourplay-stats__value">{playtime}</span>
                    {!isMobile && <span className="devourplay-stats__label">Time Played</span>}
                </div>
            </div>
            <div className="devourplay-stats__item">
                <IoGameControllerOutline className="devourplay-stats__icon" />
                <div className="devourplay-stats__content">
                    <span className="devourplay-stats__value">{gamesPlayed}</span>
                    {!isMobile && <span className="devourplay-stats__label">Games Played</span>}
                </div>
            </div>
        </div>
    );
};

export default DevourPlayStats;